var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRootKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.333 5 2.334-2.333M14 1.333l-1.333 1.334L14 1.333zM7.593 7.74a3.667 3.667 0 1 1-5.185 5.185 3.667 3.667 0 0 1 5.185-5.184V7.74zm0 0L10.333 5l-2.74 2.74zM10.333 5l2 2 2.334-2.333-2-2L10.333 5z",
    stroke: "#545454",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootKey);
export default __webpack_public_path__ + "static/media/rootKey.c057c9175869088c2dca1d1ac0b7aac7.svg";
export { ForwardRef as ReactComponent };